import messages from './memberMessagingCompose.json' with { type: 'json' };

export const memberMessagingComposeSv: Readonly<typeof messages> = messages;
